<template>
    <div class="details">
        <section
            v-for="group in detailGroups"
            :key="group.title"
            class="details-group"
        >
            <h3 class="details-title">
                {{ group.title }}
            </h3>
            <dl class="details-list">
                <div
                    v-for="item in group.items"
                    :key="item.label"
                    class="details-row"
                >
                    <dt>{{ item.label }}</dt>
                    <dd :class="item.tone && 'tone-' + item.tone">
                        {{ item.value }}
                    </dd>
                </div>
            </dl>
        </section>
    </div>
</template>

<script>
export default {
    props: ['detailGroups']
}
</script>

<style scoped>
/* ================= Details ================= */
.details {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 8px 56px;
  padding: 20px 28px 32px;
}
.details-title {
  margin: 0 0 8px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
  color: #00796b;
}
.details-list {
  margin: 0;
}
.details-row {
  display: grid;
  grid-template-columns: 9.5em 1fr;
  gap: 4px 12px;
  align-items: baseline;
  padding: 8px 0;
  border-bottom: 1px solid rgba(0, 0, 0, .08);
}
.details-row dt {
  font-size: 12px;
  font-weight: 700;
}
.details-row dd {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  overflow-wrap: anywhere;
}
.tone-ok  { color: green; }
.tone-bad { color: #800020; }
</style>